"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDataTableTgroup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbDataTableTbody = require("./sb-data-table-tbody");

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LEFT = _constants.expandedRowsArrowPositions.LEFT,
    RIGHT = _constants.expandedRowsArrowPositions.RIGHT;

var SbDataTableTgroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbDataTableTgroup, _PureComponent);

  var _super = _createSuper(SbDataTableTgroup);

  function SbDataTableTgroup() {
    _classCallCheck(this, SbDataTableTgroup);

    return _super.apply(this, arguments);
  }

  _createClass(SbDataTableTgroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cellFormatter = _this$props.cellFormatter,
          collapsed = _this$props.collapsed,
          columns = _this$props.columns,
          data = _this$props.data,
          groupBy = _this$props.groupBy,
          groupRender = _this$props.groupRender,
          onCollapse = _this$props.onCollapse,
          rowFormatter = _this$props.rowFormatter,
          rowsUniqueKeyName = _this$props.rowsUniqueKeyName,
          minIndex = _this$props.minIndex,
          maxIndex = _this$props.maxIndex,
          asyncData = _this$props.asyncData,
          expandableRowFormatter = _this$props.expandableRowFormatter,
          onExpandRow = _this$props.onExpandRow,
          expandedRows = _this$props.expandedRows,
          expandableRowsArrowPosition = _this$props.expandableRowsArrowPosition;
      var filteredData = maxIndex === -1 || asyncData ? data : (0, _utils.getSubsetOfItems)({
        minIndex: minIndex,
        maxIndex: maxIndex,
        data: data,
        collapsed: collapsed
      });
      return Object.keys(filteredData).map(function (key, groupIndex) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: "sb-data-table-tgroup-fragment-".concat(groupIndex)
        }, /*#__PURE__*/_react.default.createElement("tbody", {
          className: "sb-data-table-tbody-group ".concat((0, _utils.isCollapsed)(key, collapsed) ? 'hidden-rows' : '')
        }, /*#__PURE__*/_react.default.createElement("tr", {
          className: "sb-data-table-tgroup",
          onClick: function onClick() {
            return onCollapse(key);
          }
        }, /*#__PURE__*/_react.default.createElement("td", {
          colSpan: 100
        }, groupRender(key, groupBy, filteredData[key], filteredData)))), /*#__PURE__*/_react.default.createElement(_sbDataTableTbody.SbDataTableTbody, {
          columns: columns,
          data: filteredData[key],
          cellFormatter: cellFormatter,
          rowFormatter: rowFormatter,
          rowsUniqueKeyName: rowsUniqueKeyName,
          expandableRowFormatter: expandableRowFormatter,
          onExpandRow: onExpandRow,
          expandedRows: expandedRows,
          expandableRowsArrowPosition: expandableRowsArrowPosition
        }));
      });
    }
  }]);

  return SbDataTableTgroup;
}(_react.PureComponent);

exports.SbDataTableTgroup = SbDataTableTgroup;

_defineProperty(SbDataTableTgroup, "propTypes", {
  collapsed: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    label: _propTypes.default.node
  })).isRequired,
  data: _propTypes.default.object.isRequired,
  // eslint-disable-line
  groupBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  rowsUniqueKeyName: _propTypes.default.string,
  cellFormatter: _propTypes.default.func,
  groupRender: _propTypes.default.func,
  onCollapse: _propTypes.default.func,
  rowFormatter: _propTypes.default.func,
  minIndex: _propTypes.default.number,
  maxIndex: _propTypes.default.number,
  asyncData: _propTypes.default.bool,
  expandableRowFormatter: _propTypes.default.func,
  onExpandRow: _propTypes.default.func,
  expandedRows: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  expandableRowsArrowPosition: _propTypes.default.oneOf([LEFT, RIGHT])
});

_defineProperty(SbDataTableTgroup, "defaultProps", {
  collapsed: [],
  groupBy: null,
  rowsUniqueKeyName: null,
  cellFormatter: function cellFormatter(val) {
    return val;
  },
  groupRender: function groupRender(val) {
    return val;
  },
  onCollapse: function onCollapse() {},
  rowFormatter: function rowFormatter() {
    return {};
  },
  expandableRowFormatter: null,
  minIndex: 0,
  maxIndex: -1,
  asyncData: false,
  onExpandRow: function onExpandRow() {},
  expandedRows: [],
  expandableRowsArrowPosition: RIGHT
});
//# sourceMappingURL=sb-data-table-tgroup.js.map